import { createFileRoute, Navigate } from '@tanstack/react-router'
import { Loader2 } from 'lucide-react'
import { FounderLayout } from '../../../../components/founder-layout'
import { useStartupContext } from '../../../../contexts/startup-guard'
import { StartSessionView } from '../../../../features/pitch/components/start-session-view'
import { usePitchQuery } from '../../../../hooks/api'
import { useWorkspaceReady } from '../../../../hooks/use-workspace-ready'

export const Route = createFileRoute('/app/startup/$id/pitch_/start')({
  component: StartSessionPage,
})

function StartSessionPage() {
  const { startup, pitchDeckStatus } = useStartupContext()
  const { isResolved } = useWorkspaceReady()
  const { data: pitchOverview, isPending } = usePitchQuery(startup.id)

  if (!isResolved || isPending) {
    return (
      <div className="flex min-h-[calc(100vh-8rem)] items-center justify-center">
        <Loader2 className="size-10 animate-spin text-muted-foreground" />
      </div>
    )
  }

  // Same gate as the pitch route — a deck is required before a session exists.
  if (pitchDeckStatus === 'NONE') {
    return <Navigate to="/app/startup/$id" params={{ id: startup.id }} replace />
  }

  // A session is already being prepared or running: the pitch route owns those
  // full-screen states, so there is nothing to start here.
  const status = pitchOverview?.data?.ongoing?.status
  if (status === 'PENDING' || status === 'ACTIVE' || status === 'IN_PROGRESS') {
    return <Navigate to="/app/startup/$id/pitch" params={{ id: startup.id }} replace />
  }

  return (
    <FounderLayout activeNav="">
      <div className="mx-auto max-w-6xl py-2">
        <div className="mb-6">
          <h1 className="text-[22px] font-bold tracking-[-0.01em] text-foreground">
            Ready to pitch?
          </h1>
          <p className="mt-1 text-[13px] leading-relaxed text-muted-foreground">
            Pitch your startup to an AI investor and get scored through four investor lenses:
            recorded, shareable, and broken down on your SeedForge's Feedback tab.
          </p>
        </div>
        <StartSessionView history={pitchOverview?.data?.history} />
      </div>
    </FounderLayout>
  )
}
